/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Odd_Honest_Anteater_DigInputs */

const en_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Brave`)
};

const id_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengunduh Brave`)
};

const ms_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun Brave`)
};

const ca_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar Brave`)
};

const cs_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout Brave`)
};

const da_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Brave`)
};

const de_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Herunterladen`)
};

const et_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lae Brave alla`)
};

const es_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Brave`)
};

const fr_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez Brave`)
};

const hr_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preuzmite Brave`)
};

const it_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica Brave`)
};

const lv_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejupielādējiet Brave`)
};

const lt_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atsisiųsti „Brave“`)
};

const hu_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave letöltése`)
};

const nl_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave downloaden`)
};

const nb_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned Brave`)
};

const pl_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz Brave`)
};

const pt_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Download`)
};

const ro_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă Brave`)
};

const sk_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiahnite si Brave`)
};

const sl_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenesite Brave`)
};

const fi_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa Brave`)
};

const sv_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner Brave`)
};

const vi_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống Brave`)
};

const tr_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave'i indirin`)
};

const el_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λήψη Brave`)
};

const bg_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегли Brave`)
};

const ru_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать браузер Brave`)
};

const sr_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преузми Brave`)
};

const uk_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити Brave`)
};

const ka_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-ის გადმოწერა`)
};

const hi_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave डाउनलोड करें`)
};

const th_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลด Brave`)
};

const ko_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 다운로드`)
};

const zh_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 Brave`)
};

const zh_tw_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載 Brave`)
};

const ja_odd_honest_anteater_dig = /** @type {(inputs: Odd_Honest_Anteater_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveをダウンロード`)
};

/**
* | output |
* | --- |
* | "Download Brave" |
*
* @param {Odd_Honest_Anteater_DigInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const odd_honest_anteater_dig = /** @type {((inputs?: Odd_Honest_Anteater_DigInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Odd_Honest_Anteater_DigInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_odd_honest_anteater_dig(inputs)
	if (locale === "ms") return ms_odd_honest_anteater_dig(inputs)
	if (locale === "ca") return ca_odd_honest_anteater_dig(inputs)
	if (locale === "cs") return cs_odd_honest_anteater_dig(inputs)
	if (locale === "da") return da_odd_honest_anteater_dig(inputs)
	if (locale === "de") return de_odd_honest_anteater_dig(inputs)
	if (locale === "et") return et_odd_honest_anteater_dig(inputs)
	if (locale === "es") return es_odd_honest_anteater_dig(inputs)
	if (locale === "fr") return fr_odd_honest_anteater_dig(inputs)
	if (locale === "hr") return hr_odd_honest_anteater_dig(inputs)
	if (locale === "it") return it_odd_honest_anteater_dig(inputs)
	if (locale === "lv") return lv_odd_honest_anteater_dig(inputs)
	if (locale === "lt") return lt_odd_honest_anteater_dig(inputs)
	if (locale === "hu") return hu_odd_honest_anteater_dig(inputs)
	if (locale === "nl") return nl_odd_honest_anteater_dig(inputs)
	if (locale === "nb") return nb_odd_honest_anteater_dig(inputs)
	if (locale === "pl") return pl_odd_honest_anteater_dig(inputs)
	if (locale === "pt") return pt_odd_honest_anteater_dig(inputs)
	if (locale === "ro") return ro_odd_honest_anteater_dig(inputs)
	if (locale === "sk") return sk_odd_honest_anteater_dig(inputs)
	if (locale === "sl") return sl_odd_honest_anteater_dig(inputs)
	if (locale === "fi") return fi_odd_honest_anteater_dig(inputs)
	if (locale === "sv") return sv_odd_honest_anteater_dig(inputs)
	if (locale === "vi") return vi_odd_honest_anteater_dig(inputs)
	if (locale === "tr") return tr_odd_honest_anteater_dig(inputs)
	if (locale === "el") return el_odd_honest_anteater_dig(inputs)
	if (locale === "bg") return bg_odd_honest_anteater_dig(inputs)
	if (locale === "ru") return ru_odd_honest_anteater_dig(inputs)
	if (locale === "sr") return sr_odd_honest_anteater_dig(inputs)
	if (locale === "uk") return uk_odd_honest_anteater_dig(inputs)
	if (locale === "ka") return ka_odd_honest_anteater_dig(inputs)
	if (locale === "hi") return hi_odd_honest_anteater_dig(inputs)
	if (locale === "th") return th_odd_honest_anteater_dig(inputs)
	if (locale === "ko") return ko_odd_honest_anteater_dig(inputs)
	if (locale === "zh") return zh_odd_honest_anteater_dig(inputs)
	if (locale === "zh-tw") return zh_tw_odd_honest_anteater_dig(inputs)
	if (locale === "ja") return ja_odd_honest_anteater_dig(inputs)
	return en_odd_honest_anteater_dig(inputs)
});